<template>
  <div>
    <form>
    <div class="row pb-2">
        <div class="col-12">
            <strong>Title</strong>
            <input type="text" class="form-control" v-model="setting.title">
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <strong>Value</strong>
            <input type="text" class="form-control" v-model="setting.value">
        </div>
    </div>
    <div class="row">
        <div class="col-12 pt-2 pb-2">
            <strong>Group</strong>
            <input type="text" class="form-control" v-model="setting.group">
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <strong>Description</strong>
            <textarea v-model="setting.description" rows="5" class="form-control"></textarea>
        </div>
    </div>
    <div class="mt-4">
        <button type="submit" class="btn btn-info text-light" @click.prevent="create">
        {{ title }}
        </button>
    </div>
    </form>
  </div>
</template>
<script>
  export default {
    props: {
      setId: Number
    },
    data () {
      return {
        title : 'Create',
        setting: {
          title: '',
          description: '',
          group: '',
          value: ''
        }
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      create () {
        var method = 'post';
        var host = this.$server + 'settings';

        if (this.setId != 0) {
          method = 'put';
          host = this.$server + 'settings/' + this.setId;
        }

        this.$axios({ method, url: host, data: this.setting })
        .then(res => {
          var r = res.data;
          if (r.success) {
            this.$swal({
              title: r.message
            });
            this.$emit('callback', true);
          }
        });
      },
      init() {
        if (this.setId != 0) {
          this.title = 'Update';
          const me = this;
          this.$axios.get(this.$server + 'settings/' + this.setId)
          .then(res => {
            var r = res.data;
            if (r.success) {
              me.setting = r.data;
            }
          });
        }
        this.$emit('callback', this.title);
      }
    }
  }

</script>
